<template>
    <div class="grid grid-cols-12 gap-2">
        <div class="col-span-6">
            <FormControl
                required
                label="Price"
                :error="
                    errors?.getValidationError(
                        RequestBodyKeyEnum.App_UpdateService_Prices_Amount,
                    )
                "
            >
                <TextInput
                    :name="RequestBodyKeyEnum.App_UpdateService_Prices_Amount"
                    type="number"
                    inputmode="numeric"
                    min="1"
                    step="0.01"
                    :value="
                        servicePrice
                            ? servicePrice.price.getValueAsDecimal()
                            : 0
                    "
                />
            </FormControl>
        </div>
        <div class="col-span-6">
            <FormControl
                required
                label="Currency"
                :error="
                    errors?.getValidationError(
                        RequestBodyKeyEnum.App_UpdateService_Prices_Currency,
                    )
                "
            >
                <SelectInput
                    :name="RequestBodyKeyEnum.App_UpdateService_Prices_Currency"
                    v-model="dummySelectedPriceCurrency"
                    required
                >
                    <template
                        v-for="currency in CurrencyEnumList"
                        :key="currency.key"
                    >
                        <option :value="currency.key">
                            {{ currency.label }}
                        </option>
                    </template>
                </SelectInput>
            </FormControl>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import { CurrencyEnum, CurrencyEnumList } from '@/Shared/AutoGenerated/Main'
    import ServicePrice from '@/App/Service/Entity/ServicePrice'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        servicePrice: {
            type: Object as PropType<ServicePrice>,
            default: null,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const dummySelectedPriceCurrency = props.servicePrice
        ? props.servicePrice.price.currency
        : CurrencyEnum.USD
</script>
